<template>
  <component
    :is="comp"
    class="bg-static-info-low rounded-lg relative flex flex-row items-center p-8"
    :class="{
      'hover:bg-static-info-mid-hover focus:bg-static-info-mid-hover motion-safe:transition-colors motion-safe:duration-200 motion-safe:ease-in':
        hasLink,
    }"
    @click="emit('click')"
  >
    <RevTag
      v-if="withNewTag"
      class="absolute -top-4 right-32"
      :label="i18n(translations.newTag)"
      variant="primary"
    />
    <div
      class="mr-8 flex h-40 w-40 shrink-0 items-center justify-center md:h-48 md:w-48"
    >
      <slot name="icon" />
    </div>
    <div class="flex w-full items-center justify-between text-left">
      <div class="flex flex-col">
        <div class="body-2-bold">
          <slot name="title" />
        </div>
        <div class="caption">
          <slot name="subtitle" />
        </div>
      </div>
      <div class="ml-8 flex h-40 w-40 items-center">
        <IconChevronRight v-if="hasLink" class="h-24 w-full" />
      </div>
    </div>
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './ReassuranceItem.translations'

const props = withDefaults(
  defineProps<{
    hasLink?: boolean
    withNewTag?: boolean
  }>(),
  { hasLink: false, withNewTag: false },
)

const emit = defineEmits(['click'])

const i18n = useI18n()

const comp = computed(() => {
  return props.hasLink ? 'button' : 'div'
})
</script>
